/* @flow */

import React from 'react';

type TextSearchProps = {
    id: string,
    placeholder: string,
    name: string,
    maxLength: number,
};

function processSearch(event) {
    const inputValue = event.currentTarget.value;
    // if enter pressed
    if (event.which === 13 || event.keyCode === 13) {
        // be sure that at least n characters are given
        if (inputValue.length < 1) {
            event.preventDefault();
        }
    }
}

const TextSearch = ({ id, placeholder, name, maxLength }: TextSearchProps) => (
    <form className="form-inline" method="get">
        <div className="form-group">
            <div className="input-group">
                <input
                    name={name}
                    type="text"
                    size={maxLength}
                    className="form-control"
                    id={id}
                    placeholder={placeholder}
                    onKeyPress={processSearch}
                />
                <div className="input-group-addon">
                    <i
                        className="fa fa-search"
                        onClick={e =>
                            window
                                .jQuery(e.target)
                                .closest('form')
                                .submit()}
                    />
                </div>
            </div>
        </div>
    </form>
);

export default TextSearch;



// WEBPACK FOOTER //
// ./resources/assets/admin/global/js/components/TextSearch.js